"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _history = require("../actions/history");

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var _default = function _default(history) {
  return function () {
    return function (next) {
      return function (action) {
        var payload = action.payload,
            type = action.type;

        if (type === _history.PUSH) {
          var _a = payload.split('#'),
              pathname = _a[0],
              hash = _a[1];

          history.push({
            pathname: pathname,
            hash: hash
          });
          return next(__assign(__assign({}, action), {
            payload: history.location
          }));
        }

        if (type === _history.REPLACE) {
          history.replace(payload);
          return next(__assign(__assign({}, action), {
            payload: history.location
          }));
        }

        if (type === _history.GO) {
          history.go(payload);
          return next(__assign(__assign({}, action), {
            payload: history.location
          }));
        }

        if (type === _history.GO_FORWARD) {
          history.goForward();
          return next(__assign(__assign({}, action), {
            payload: history.location
          }));
        }

        if (type === _history.GO_BACK) {
          history.goBack();
          return next(__assign(__assign({}, action), {
            payload: history.location
          }));
        }

        return next(action);
      };
    };
  };
};

exports.default = _default;